import React from 'react';
import useSWR from 'swr';
import { Flex, Image, Text } from 'rebass';
import { CurrentCollectionProvider } from '../collections/current-collection-context';
import { ScrollProvider } from './scroll';
import { TagContextProvider } from '../collections/detail/tag-context';
import NotificationsWrap from '../notifications/wrap';
import MemberSubscription from '../members/profile/subscription';
import CurrentModal from '../app/modal/context';
// import { useMemberConnectionsSWR } from '../members/api';
import { useCurrentMemberId } from '../members/hooks/index';
import { getSWR } from '../utils/api';
import { useDrawer } from './DrawerContext';
import Modal from 'app/modal/v3/index';
import { LetsBeginFooterComponent } from 'stories/new/global/lets-begin';

const AuthorizedContext = props => {
  // const memberId = useCurrentMemberId();
  // useMemberConnectionsSWR({ memberId });
  const { firstTimeUserModal, closeFirstTimeUserModal } = useDrawer();

  // useSWR(`/v2/members/${memberId}/identifiers`, getSWR, {
  //   shouldRetryOnError: false,
  //   revalidateOnFocus: false,
  // });
  // useMemberEventsSWR({});

  return (
    // <NotificationsWrap>
    <CurrentModal>
      {firstTimeUserModal && <Modal
        close={{ onClose: closeFirstTimeUserModal }}
        maxWidth={620}
        closeOnOutsideClick={false}
        isScrollActive={false}
        aboveTooltip
        shadeProps={{ pt: [0, 4] }}
      >
        <Flex m="auto" mb={["200px", "50px"]} flexDirection="column" justifyContent="center" alignItems="center" maxWidth={400}>
          <Text fontFamily="Bitter" fontWeight="normal"
            sx={{
              color: '#000',
              fontFamily: 'Bitter',
              fontSize: '30px',
              fontWeight: '500',
              lineHeight: '165%',
            }}
            px="26px"
            textAlign='left'
          >
            Chapters help organize your book content
          </Text>
          <Text
            color="#64748B"
            fontFamily="Poppins"
            fontSize="18px"
            fontStyle="normal"
            fontWeight={400}
            lineHeight="200%"
            letterSpacing="-0.36px"
            textAlign='left'
            mb="30px"
            px="26px"
          >
            Use the default chapter list as a guide or create your own by editing your chapters in the sidebar menu.
          </Text>

          <LetsBeginFooterComponent
            sx={{ justifyContent: 'center', }}
            onStepUp={closeFirstTimeUserModal}
            nextButtonText="Awesome"
          />
        </Flex>
      </Modal>}
      <ScrollProvider>
        <CurrentCollectionProvider>
          <MemberSubscription>
            <TagContextProvider {...props} />
          </MemberSubscription>
        </CurrentCollectionProvider>
      </ScrollProvider>
    </CurrentModal>
    // </NotificationsWrap>
  );
};

export default AuthorizedContext;
